import { AmenitiesExpandableList } from '@/entities/amenity';
import type { FC } from 'react';
import { InfoCard1 } from './info-cards/info-card-1';
import { InfoCard2 } from './info-cards/info-card-2';
import { InfoCard3 } from './info-cards/info-card-3';

type SingleFacilityInfoTabProps = {
  facilityId: string;
};

export const SingleFacilityInfoTab: FC<SingleFacilityInfoTabProps> = ({
  facilityId,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4">
        <InfoCard1 facilityId={facilityId} />
        <InfoCard2 facilityId={facilityId} />
        <InfoCard3 facilityId={facilityId} />
      </div>

      <AmenitiesExpandableList facilityId={facilityId} />
    </div>
  );
};
